/** Text style resolution — shared by the right panel's toolbar and the preview's burned-in look. */
import React from 'react';
import { TextStyleFields, TextSizePreset } from './types';
import { DEFAULT_TEXT_STYLE, TEXT_SIZE_PRESETS, legacyPxToPct } from './constants';

export function resolveTextStyle(fields: TextStyleFields | null | undefined) {
  const sizePreset = fields?.sizePreset ?? DEFAULT_TEXT_STYLE.sizePreset;
  const preset = TEXT_SIZE_PRESETS.find(p => p.value === sizePreset);
  const fontSizePct = sizePreset === 'custom'
    ? (fields?.fontSizePct ?? legacyPxToPct(fields?.fontSize, DEFAULT_TEXT_STYLE.fontSizePct))
    : (preset?.pct ?? DEFAULT_TEXT_STYLE.fontSizePct);
  return {
    fontFamily: fields?.fontFamily ?? DEFAULT_TEXT_STYLE.fontFamily,
    sizePreset,
    fontSizePct,
    bold: fields?.bold ?? DEFAULT_TEXT_STYLE.bold,
    italic: fields?.italic ?? DEFAULT_TEXT_STYLE.italic,
    underline: fields?.underline ?? DEFAULT_TEXT_STYLE.underline,
    color: fields?.color ?? DEFAULT_TEXT_STYLE.color,
    bgColor: fields?.bgColor ?? DEFAULT_TEXT_STYLE.bgColor,
  };
}

/**
 * The percentage is resolved against the live preview frame, so what is on screen is the same
 * proportion ffmpeg burns at 1080x1920. `frameHeight` of 0 means the frame has not been
 * measured yet — fall back to the 1920-tall canvas the render targets.
 */
export function textStyleToCss(fields: TextStyleFields | null | undefined, frameHeight: number): React.CSSProperties {
  const style = resolveTextStyle(fields);
  const basis = frameHeight > 0 ? frameHeight : 1920;
  return {
    fontFamily: `'${style.fontFamily}', sans-serif`,
    fontSize: `${(basis * style.fontSizePct) / 100}px`,
    fontWeight: style.bold ? 700 : 500,
    fontStyle: style.italic ? 'italic' : 'normal',
    textDecoration: style.underline ? 'underline' : 'none',
    color: style.color,
    lineHeight: 1.25,
    ...(style.bgColor ? { background: style.bgColor } : {}),
  };
}
